"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapUtils = void 0;
class MapUtils {
    static arrayToMap(arrayObj, keyToUseInMap, opts) {
        const map = new Map();
        arrayObj?.map(arrayObject => {
            const normalizedKey = opts?.keyNormalizer
                ? opts.keyNormalizer(arrayObject[keyToUseInMap])
                : arrayObject[keyToUseInMap];
            map.set(normalizedKey, arrayObject);
        });
        return map;
    }
    static arrayToMapLambda(arrayObj, generateKey, opts = { selectValue: v => v }) {
        const map = new Map();
        arrayObj.map(obj => {
            const key = generateKey(obj);
            map.set(key, opts.selectValue(obj));
        });
        return map;
    }
    static groupBy(arrayObj, pathStr, opts) {
        const map = new Map();
        const path = pathStr.split('.');
        arrayObj?.forEach(obj => {
            let keyToUseInMap = obj;
            for (const key of path)
                keyToUseInMap = keyToUseInMap?.[key];
            const normalizedKey = opts?.keyNormalizer ? opts.keyNormalizer(keyToUseInMap) : keyToUseInMap;
            if (!map.has(normalizedKey))
                map.set(normalizedKey, []);
            map.get(normalizedKey)?.push(obj);
        });
        return map;
    }
}
exports.MapUtils = MapUtils;
